import React            from 'react';
import ButtonChoice     from '../Fields/ButtonChoice';
import FieldValidation  from '../Fragments/FieldValidation';

let Quote = require('../Managers/Quote');

const AddressEntry = React.createClass({
    propTypes: {
        fieldNamePrefix: React.PropTypes.string.isRequired,
        pafLookup: React.PropTypes.bool.isRequired,
        postcodeFunction:  React.PropTypes.func,
        helpText: React.PropTypes.string,
        question: React.PropTypes.string.isRequired
    },
    getInitialState() {
        let _isCountrySet = false;
        let _isUK = '';
        if (Quote.getCurrentAnswer('is_cor_address_uk') != undefined) {
            _isCountrySet = true;
            _isUK = Quote.getCurrentAnswer('is_cor_address_uk');
        }

        return {
            isHelpVisible: false,
            isValid: this.isValid(),
            hasError: false,
            pafLookupPostcode: false,
            isUK: _isUK,
            isCountrySet: _isCountrySet,
        };
    },

    setValue: function(event) {
        if (event.target.name === '_address_postcode') {
            let cleanPostcode = event.target.value.replace(/ /g,'').toUpperCase();

            Quote.set(this.props.fieldNamePrefix+event.target.name, cleanPostcode);
            if (this.props.postcodeFunction) {
                this.props.postcodeFunction(cleanPostcode);
            }
        } else {
            if (event.target.name == 'country') {
                Quote.set(event.target.name, event.target.value);
            } else {
                Quote.set(this.props.fieldNamePrefix+event.target.name, event.target.value);
            }
        }

        // @TODO remove this - we dont actually need cor at all, but
        // the validation throws a wobbly if its not sorted. so fix the
        // validation
        Quote.set('cor', event.target.value);

        if (this.isValid()) {
            this.setState({
                isValid: true
            });
        } else {
            this.setState({
                isValid: false
            });
        }
    },

    setCountry: function(value) {
        this.setState({
            isUK: value,
            isCountrySet: true
        });
    },

    doValidation() {
        if (!this.isValid()) {
            this.setState({
                hasError : true,
                errors : ["Please complete this question"]
            });
            return false;
        }
        return true;
    },

    toggleHelpText: function() {
        this.setState({
            isHelpVisible: (this.state.isHelpVisible) ? false : true,
        });
    },

    isValid() {
        return Quote.hasAnswers(
            this.props.fieldNamePrefix+'_address_line1',
            this.props.fieldNamePrefix+'_address_line2',
            this.props.fieldNamePrefix+'_address_line3',
            this.props.fieldNamePrefix+'_address_postcode'
        );
    },

    setPafLookupPostcode: function(event) {
        let pc = event.target.value.toUpperCase();
        if (pc.length > 4) {
            this.setState({
                pafLookupPostcode: event.target.value
            });
        }
    },
    pafLookup: function() {

    },

    render() {
        return (
            <div>
                <ButtonChoice
                    question="Is your correspondence address in the UK?"
                    fieldName="is_cor_address_uk"
                    loadCachedValue={true}
                    children={[]}
                    questionId={0}
                    defaultValue={this.state.isUK}
                    helpText={this.props.helpText}
                    onSetValue={this.setCountry}
                    options={[
                        {
                            option_text: 'Yes',
                            option_value: 'yes'
                        },
                        {
                            option_text: 'No',
                            option_value: 'no'
                        }
                    ]} />

            {this.state.isCountrySet ?
            <question-row>
                <div className="question-main">
                    <div className="question-top">
                        <h2>{this.props.question}</h2>
                    </div>

                    <div className="question-input">
                        {/**<div className="input-group">
                            <input type="text" name="pafsource" onBlur={this.setPafLookupPostcode} />
                            <button className="btn btn-default" onClick={this.pafLookup}>Find my address</button>
                        </div>*/}
                        <div className="address-entry-wrapper" id={this.props.fieldNamePrefix}>
                            <label className="compound-component">Address Line 1</label>
                            <input
                                type="text"
                                defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line1")}
                                onBlur={this.setValue}
                                id={this.props.fieldNamePrefix + '_address_line1'}
                                name="_address_line1" />

                            <label className="compound-component">Address Line 2</label>
                            <input
                                type="text"
                                defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line2")}
                                onBlur={this.setValue}
                                id={this.props.fieldNamePrefix + '_address_line2'}
                                name="_address_line2" />

                            <label className="compound-component">Address Line 3</label>
                            <input
                                type="text"
                                defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_line3")}
                                onBlur={this.setValue}
                                id={this.props.fieldNamePrefix + '_address_line3'}
                                name="_address_line3" />

                            <label className="compound-component">Postcode</label>
                            <input
                                type="text"
                                defaultValue={Quote.getCurrentAnswer(this.props.fieldNamePrefix+"_address_postcode")}
                                onBlur={this.setValue}
                                id={this.props.fieldNamePrefix + '_address_postcode'}
                                name="_address_postcode" />
                            {this.props.fieldNamePrefix == 'cor' && this.state.isUK == 'no' ?
                                <div>
                                    <label className="compound-component">Country</label>
                                    <input
                                        type="text"
                                        defaultValue={Quote.getCurrentAnswer("country")}
                                        onBlur={this.setValue}
                                        id="country"
                                        name="country" />
                                </div>
                            : null}
                        </div>
                    </div>
                </div>
                <div className="question-extra">
                    <FieldValidation isValid={this.state.isValid} hasError={this.state.hasError} />
                </div>
            </question-row>
            :null}
            </div>
        );
    }
});

export default AddressEntry;



/** WEBPACK FOOTER **
 ** ./src/components/Fragments/AddressEntry.js
 **/